import { Fragment, useState, useEffect } from "react";
import { useTranslations } from "next-intl";
import { useCurrentUser } from "@hooks/use-current-user";
import Link from "@components/core/Link";
import { useRouter } from "next/compat/router";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";

const CatalogBreadcrumb = ({ breadcrumbs }) => {
  const t = useTranslations("common");

  const user = useCurrentUser();
  const router = useRouter();

  const [breadcrumbsLinks, setBreadcrumbsLinks] = useState([]);

  const displayLinkHref = (linkHref) => {
    return `/${linkHref}`;
  };

  function sendTrackerData(linkHref) {
    const defaultEventData = {
      tracking_name: "catalogBreadcrumb",
      page: router?.asPath,
      link: `/${linkHref}`,
    };

    ahoy("$click", defaultEventData);
    analytics.track("$click", defaultEventData);
  }

  function displayLinks() {
    if (!breadcrumbs || breadcrumbs?.length === 0) return [];

    return breadcrumbs.reduce(
      (accumulator, { id, title, slug }) => {
        accumulator.paths.push(slug);
        const linkHref = accumulator.paths.join("/");
        accumulator.links.push(
          <Fragment key={id}>
            <Link
              href={displayLinkHref(linkHref)}
              prefetch={false}
              className="link-gray"
              noUnderline
              data-testid={`catalog-breadcrumb-${slug}`}
              onClick={() => sendTrackerData(linkHref)}
            >
              /&nbsp;
              {title}
              &nbsp;
            </Link>
          </Fragment>,
        );

        return accumulator;
      },
      {
        links: [],
        paths: [],
      },
    );
  }

  useEffect(() => {
    setBreadcrumbsLinks(displayLinks());
  }, [breadcrumbs]);

  if (breadcrumbs.length === 0) return null;

  return (
    <div className="d-flex flex-wrap justify-content-center font-size-xs text-uppercase mb-1">
      <Link
        href={user ? "/home" : "/"}
        className="link-gray"
        noUnderline
      >
        {t("home_page")}
        &nbsp;
      </Link>
      {breadcrumbsLinks.links}
    </div>
  );
};

export default CatalogBreadcrumb;
